import { render, staticRenderFns } from "./informManagement.vue?vue&type=template&id=00576a4a&scoped=true"
import script from "./informManagement.vue?vue&type=script&lang=js"
export * from "./informManagement.vue?vue&type=script&lang=js"
import style0 from "./informManagement.vue?vue&type=style&index=0&id=00576a4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00576a4a",
  null
  
)

export default component.exports